export default {"src":"/_next/static/media/frame7.7b9777d2.svg","height":109,"width":232,"blurWidth":0,"blurHeight":0};